import {Mutation} from 'vuex';
import {IModuleState} from './types';

// 展示列表
export const setDpsPage: Mutation<IModuleState> = (state, payload) => {
    state.dpsPage.data = payload.data;
    state.dpsPage.pageNum = payload.pageNum;
    state.dpsPage.pageSize = payload.pageSize;
    state.dpsPage.total = payload.total;
    state.dpsPage.loading = !!payload.loading;
};

// 展示内容列表
export const setDpscPage: Mutation<IModuleState> = (state, payload) => {
    state.dpscPage.data = payload.data;
    state.dpscPage.pageNum = payload.pageNum;
    state.dpscPage.pageSize = payload.pageSize;
    state.dpscPage.total = payload.total;
    state.dpscPage.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
    state.confirm.visible = !!payload.visible;
    state.confirm.loading = !!payload.loading;
    state.confirm.title = payload.title;
    state.confirm.content = payload.content;
    state.confirm.name = payload.name;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
    state.search = payload;
};

// 展示内容搜索条件
export const setDpscSearch: Mutation<IModuleState> = (state, payload) => {
    state.dpscSearch = payload;
};

// 加载状态
export const setLoading: Mutation<IModuleState> = (state, payload) => {
    state.loading = !!payload;
};
